import { makeSelectors } from '@utils/css';

const content = "_35sc1j6o5p3";
const tileContent = "_35st1fu3svm";
const tileSelectors = makeSelectors({
  tile: content,
  content: tileContent
});

export { content, tileContent, tileSelectors };
import "./_tile-input.style.linaria.module.css";
//# sourceMappingURL=_tile-input.style.js.map
